// 🌐 CONFIGURAÇÃO DE URLs - ERP NASCIMENTO
// Centraliza todas as URLs de API e navegação
// Usa variáveis de ambiente em produção, localhost em desenvolvimento

const isProduction = process.env.NODE_ENV === 'production';

// Quando REACT_APP_BACKEND_URL está definido (ex: Docker), todos os serviços
// passam pelo mesmo backend (monolito). Caso contrário usa portas individuais em dev.
const backendOverride = process.env.REACT_APP_BACKEND_URL;

function backendUrl(path, devPort) {
  if (backendOverride) return `${backendOverride}${path}`;
  if (isProduction) return `https://api.grpnascimento.com.br${path}`;
  return `http://localhost:${devPort}${path}`;
}

export const API_URLS = {
  AUTH:                backendUrl('/api/auth', 5000),
  PERMISSOES:          backendUrl('/api/permissoes', 5001),
  TAREFAS:             backendUrl('/api/tarefas', 5012),
  ESTOQUE:             backendUrl('/api/estoque', 5002),
  COTACOES:            backendUrl('/api/cotacoes', 5003),
  MANUTENCAO:          backendUrl('/api/manutencao', 5004),
  CONTRATOS_VIGENTES:  backendUrl('/api/contratos-vigentes', 5006),
  CONTROLE_ANUAL:      backendUrl('/api/controle-anual', 5007),
  GRADE_LICITACAO:     backendUrl('/api/grade-licitacao', 5008),
  METAS:               backendUrl('/api/metas', 5009),
  CRIAR_CONTRATOS:     backendUrl('/api/criar-contratos', 5010),
  SOLICITACOES_VAGAS:  backendUrl('/api/solicitacoes-vagas', 5012),
  ENTREVISTAS_VAGAS:   backendUrl('/api/entrevistas-vagas', 5012),
  BD_NEGATIVO:         backendUrl('/api/bd-negativo', 5012),
  DEMISSOES_SOLICITADAS: backendUrl('/api/demissoes-solicitadas', 5014),
};

// Frontend URLs (para navegação entre dashboards)
const FRONTEND_BASE = isProduction
  ? 'https://grpnascimento.com.br'
  : 'http://localhost';

export const FRONTEND_URLS = {
  LOGIN: isProduction
    ? 'https://app.grpnascimento.com.br'
    : 'http://localhost:3001',
    
  DASHBOARD: isProduction
    ? `${FRONTEND_BASE}`
    : 'http://localhost:3000',
    
  LICITACAO: isProduction
    ? `${FRONTEND_BASE}` // Em produção, usar rotas internas
    : 'http://localhost:3002',
    
  COMPRAS: isProduction
    ? `${FRONTEND_BASE}`
    : 'http://localhost:3016',
    
  FINANCEIRO: isProduction
    ? `${FRONTEND_BASE}`
    : 'http://localhost:3018',
    
  OPERACIONAL: isProduction
    ? `${FRONTEND_BASE}`
    : 'http://localhost:3019',
    
  RELATORIOS_POWERBI: isProduction
    ? `${FRONTEND_BASE}`
    : 'http://localhost:3013',
    
  BASE_CONTRATOS_ATIVOS: isProduction
    ? `${FRONTEND_BASE}`
    : 'http://localhost:3014',
};

// Navegação (compatibilidade com código antigo)
export const ROUTES = {
  URLS: FRONTEND_URLS
};

export default {
  API_URLS,
  FRONTEND_URLS,
  ROUTES,
  isProduction
};
